import { configuration } from "@/lang/pt_BR";
import { WhitelabelProducer } from "@/types/Producer";

export const producers: WhitelabelProducer[] = [
  {
    id: [ "0" ],
    active: true,
    slug: "",
    domain: "ingressodevantagens.com.br",
    title: "Ingresso de Vantagens",
    footer: "Uma empresa do Grupo Dataclick",
    theme: "base",
    favicon: "img/icons/favicon-196.png",
    locale: configuration.default,
    analytics: [
      "G-3FRE63HPHD",
      "230989696734366",
    ],
  },
  {
    id: [ "f22a4430-c4d9-11ec-b892-ef25fe858e6b" ],
    active: true,
    domain: "jec.ingressodevantagens.com.br",
    slug: "jec-futsal",
    title: "JEC Krona",
    footer: "Uma empresa do Grupo Dataclick",
    theme: "jec",
    favicon: "img/icons/favicon-196.png",
    locale: configuration.default,
  },
  {
    id: [ "c0a43340-b476-11ee-901b-bd30cdc86c8d" ],
    active: true,
    domain: "barra.ingressodevantagens.com.br",
    slug: "barra",
    title: "Barra FC",
    footer: "Uma empresa do Grupo Dataclick",
    theme: "barra",
    favicon: "img/icons/favicon-196.png",
    locale: configuration.default,
    analytics: [
      "218154797957065",
    ],
  },
  {
    id: [ "0de57220-b12b-11e8-8ee6-5f76827d02a6" ],
    active: true,
    domain: "dataclick.ingressodevantagens.com.br",
    slug: "dataclick",
    title: "DTKSports",
    footer: "Uma empresa do Grupo Dataclick",
    theme: "base",
    favicon: "img/icons/favicon-196.png",
    locale: configuration.default,
    analytics: [
      "230989696734366",
    ],
  },
  {
    id: [ "93b39f20-da54-11ef-b2d0-c7b4af5ee45e" ],
    active: true,
    domain: "itajai.ingressodevantagens.com.br",
    slug: "itajai",
    title: "Prefeitura de Itajaí",
    footer: "Secretaria Municipal de Tecnologia",
    theme: "itajai",
    favicon: "img/icons/favicon-196.png",
    locale: configuration.default,
    analytics: [
      "1270048361091568",
    ],
  },
  {
    id: [ "bdabcc90-f3b2-11ef-8042-df79c9b6e72d" ],
    active: true,
    domain: "lounge.maracanaclub.com.br",
    slug: "maracana",
    title: "Maracanã Club",
    footer: "Powered by Ingresso de Vantagens",
    theme: "maracana",
    favicon: "https://storage.torcedordevantagens.com.br/ticket/bdabcc90-f3b2-11ef-8042-df79c9b6e72d/favicon.png",
    locale: configuration.maracana,
    analytics: [
      "G-4GBBZ43J9F",
    ],
  },
  {
    id: [ "bdabcc90-f3b2-11ef-8042-df79c9b6e72d" ],
    active: true,
    domain: "vendas.maracanaclub.com.br",
    slug: "maracana",
    title: "Maracanã Club",
    footer: "Powered by Ingresso de Vantagens",
    theme: "maracana",
    favicon: "https://storage.torcedordevantagens.com.br/ticket/bdabcc90-f3b2-11ef-8042-df79c9b6e72d/favicon.png",
    locale: configuration.maracana,
    analytics: [
      "G-4GBBZ43J9F",
    ],
  },
  {
    id: [
      "9aaeb710-7909-4247-a441-1201f1134060",
      "83ca7002-0f08-4ee7-bfda-c1dba69fa484",
      "ea6af85d-2bc8-4ddd-9fe8-6c668a484520",
      "37f5701c-3b58-441e-ac07-f0a1f3621548",
      "f22a4430-c4d9-11ec-b892-ef25fe858e6b",
      "1c149b90-c70c-46e4-8a8f-5e08a2f58c14",
    ],
    active: true,
    domain: "lnftickets.com.br",
    slug: "lnf",
    title: "LNF Tickets",
    footer: "Powered by Ingresso de Vantagens",
    theme: "lnf",
    favicon: "img/icons/favicon-196.png",
    locale: configuration.lnf,
    analytics: [
      "G-T4YC9CB1Z7",
    ],
  },
  {
    id: [ "af1d3c72-f7ea-4fbf-a5f3-7b468df504bb" ],
    active: true,
    slug: "",
    domain: "ingressos.galodamassa.com.br",
    title: "Ingressos | Galo da Massa",
    footer: "Powered by Ingresso de Vantagens",
    theme: "operario",
    favicon: "img/icons/favicon-196.png",
    locale: configuration.default,
    analytics: [],
  },
  {
    id: [ "47fa2cd8-6440-4bc7-a7bd-06d0eb95c000" ],
    active: true,
    slug: "",
    domain: "tour.ingressodevantagens.com.br",
    title: "Maracanã Tour | Ingressos",
    footer: "Powered by Ingresso de Vantagens",
    theme: "maracana_tour",
    favicon: "img/icons/favicon-196.png",
    locale: configuration.default,
    analytics: [],
  },
  {
    id: [ "22432ff6-9b4b-4c69-aea4-457e1664a9c2" ],
    active: true,
    slug: "",
    domain: "vitatickets.ingressodevantagens.com.br",
    title: "VitaTickets",
    footer: "Powered by Ingresso de Vantagens",
    theme: "vitafor",
    favicon: "img/icons/favicon-196.png",
    locale: configuration.default,
    analytics: [],
  },
  {
    id: [ "b8e48903-815b-439a-95ff-82fcba157bfa" ],
    active: true,
    slug: "",
    domain: "ingressos.jecfutsalexperience.com.br",
    title: "JEC Futsal Experience",
    footer: "Powered by Ingresso de Vantagens",
    theme: "jec",
    favicon: "img/icons/jec-favicon.ico",
    locale: configuration.default,
    analytics: [ "G-J2ZV11MN8Q" ],
  },
  {
    id: [ "83cbb0e6-834f-4037-9452-7c1ab74a55de" ],
    active: true,
    slug: "",
    domain: "ingressos.cbtm.org.br",
    title: "Ingressos | CBTM",
    footer: "Powered by Ingresso de Vantagens",
    theme: "cbtm",
    favicon: "img/icons/favicon-cbtm.ico",
    locale: configuration.default,
    analytics: [],
  },
  {
    id: [ "0a19378c-cfa6-4711-93e5-98ddc6cc0a3b" ],
    active: true,
    slug: "",
    domain: "mvatickets.com.br",
    title: "MVA Tickets",
    footer: "Powered by Ingresso de Vantagens",
    theme: "mva",
    favicon: "img/icons/favicon-mva.png",
    locale: configuration.default,
    analytics: [
      "G-M990L8G4D3",
    ],
  },
  {
    id: [ "0d5a9436-03d3-4f0d-9e04-5367c62e41e9" ],
    active: true,
    slug: "",
    domain: "maxtickets.com.br",
    title: "Max Tickets",
    footer: "Powered by Ingresso de Vantagens",
    theme: "max",
    favicon: "img/icons/favicon-max.png",
    locale: configuration.max,
    analytics: [
      "481264894410607",
      "G-9JMGSH8T8L",
    ],
    pages: {
      aboutUs: {
        component: () => import("@/views/about-us/max-tickets.vue"),
      },
    },
  },
  {
    id: [
      "3c409710-b575-46d8-9026-219bde66d4e1",
      "851fd431-9c3d-4d36-90f4-910df8fb3d2a",
    ],
    active: true,
    slug: "",
    domain: "cluberun.com.br",
    title: "Clube Run",
    footer: "Powered by Ingresso de Vantagens",
    theme: "cluberun",
    favicon: "img/icons/favicon-cluberun.png",
    locale: configuration.cluberun,
    analytics: [
      "G-WBZGX5H23N",
    ],
    pages: {
      aboutUs: {
        component: () => import("@/views/about-us/clube-run.vue"),
      },
      privacyPolicy: {
        component: () => import("@/views/privacy-policy/clube-run.vue"),
      },
      cancelationPolicy: {
        component: () => import("@/views/cancelation-policy/clube-run.vue"),
      },
      termsOfService: {
        component: () => import("@/views/terms-of-service/clube-run.vue"),
      },
      halfPricePolicy: {
        show: false,
      },
      faq: {
        show: false,
      },
    },
  },
];

export const initial = producers[0];
